import Vue from 'vue';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

Swiper.use([Navigation, Pagination]);

Vue.component('four-columns-block-slider', {
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        this.swiperInit();
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        swiperInit() {
            this.slider = new Swiper(this.$refs.slider, {
                modules: [Navigation, Pagination],
                loop: false,
                breakpoints: {
                    0: {
                        slidesPerView: 1.2,
                        spaceBetween: 20,
                        slidesOffsetAfter: 40,
                    },
                    600: {
                        slidesPerView: 2.5,
                        slidesPerGroup: 2,
                        spaceBetween: 40,
                        slidesOffsetAfter: 80,
                    },
                    1280: {
                        slidesPerView: 3,
                        slidesPerGroup: 3,
                        spaceBetween: 40,
                        slidesOffsetAfter: 80,
                    },
                    1440: {
                        slidesPerView: 4,
                        slidesPerGroup: 4,
                        spaceBetween: 40,
                        slidesOffsetAfter: 0,
                    },
                },
                navigation: {
                    nextEl: this.$refs.fourColumnsNext,
                    prevEl: this.$refs.fourColumnsPrev,
                },
                pagination: {
                    el: this.$refs.fourColumnsPagination,
                    bulletClass: 'highlighted-item__pagination-bullet',
                    bulletActiveClass: 'highlighted-item__pagination-bullet--active',
                },
            });
        },
    },
});
